<template>
  <div class="invite-add-button">
    <v-btn class="no-margin" outline @click="add">
      Створити запрошення
    </v-btn>

    <v-dialog v-model="opened" max-width="700">
      <v-card>
        <v-card-title>
          Створення запрошення
        </v-card-title>
        <v-card-text>
          <invite-form
            :invite.sync="invite"
          ></invite-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            @click="opened = false"
            :disabled="saving"
          >Відмінити</v-btn>
          <v-btn
            outline
            @click="save"
            :disabled="saving"
          >
            <v-progress-circular
              v-if="saving"
              :size="24"
              color="grey"
              indeterminate
            ></v-progress-circular>
            <span v-else>Створити</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import moment from 'moment';

import { randomString } from '@/services/random';
import InviteForm from '@/components/InviteForm';

import { createInvite } from '@/firebase/repositories/invites';

export default {
  name: 'InviteAddButton',
  components: {
    InviteForm,
  },
  data() {
    return {
      saving: false,
      opened: false,
      invite: {
        id: null,
        title: null,
        roles: {},
        email: {},
      },
    };
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
  },
  methods: {
    init() {
      const key = randomString(40);

      this.invite = {
        id: key,
        title: `${String(key).substr(0, 4)}...${String(key).substr(-4)}`,
        email: {},
        roles: {
          member: true,
          inviter: true,
        },
        author: {
          uid: this.auth.uid,
          email: this.auth.email,
          name: this.auth.displayName,
        },
      };
    },
    add() {
      this.init();
      this.opened = true;
    },
    save() {
      const { id, title, email, roles, author, sendNotifications } = this.invite;
      const invite = {
        title,
        email,
        roles,
        created: moment().valueOf(),
        author,
        sendNotifications: sendNotifications || null,
      };

      this.saving = true;
      createInvite(id, invite)
        .then(() => {
          this.saving = false;
          this.opened = false;
          this.$emit('created');
        });
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/containers/InviteAddButton.vue